<template>
  <div class="d-flex justify-center">
    <div class="product-color-count">
      <div :class="`d-flex align-center flex-wrap ${mobile ? '' : 'justify-center'}`">
        <div class="d-flex align-center flex-wrap my-3">
          <div class="product-color-count-price">¥{{ $n(harvest.sales_price) }}</div>
          <div class="mx-1">×</div>

          <div class="product-color-count-price">{{ harvest.min_count }}</div>
          <div class="unit">本</div>
          <div class="mx-1">×</div>

          <v-select v-model="setCount" :items="lots" style="width: 75px;" class solo />
          <div class="unit mx-2">口</div>

        </div>
      </div>

      <v-divider class="my-3" />

      <div class="product-color-total d-flex align-center justify-end">
        <div class="product-color-total-price">¥{{ $n(harvest.sales_price) }}</div>
        <div class="mx-1">×</div>

        <div class="product-color-total-price">{{ harvest.min_count }}</div>
        <div class="unit">本</div>
        <div class="mx-1">×</div>

        <div class="product-color-total-price">{{ setCount }}</div>
        <div class="unit">口</div>

        <div class="mx-2">=</div>
        <div class="product-color-total-sum"><span class="product-color-total-unit">¥</span>{{ $n(harvest.sales_price*harvest.min_count*setCount) }}<span
            class="product-color-total-delivery-fee">（内送料¥{{ $n(harvest.delivery_fee*harvest.min_count*setCount) }}）</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import times from "@/helpers/times";

export default {
  props: {
    harvest: {
      type: Object,
      default: null
    },
    includesZero: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: null
    }
  },

  watch: {
    setCount() {
      this.$emit("input", this.setCount * this.harvest.min_count);
    },
    harvest: {
      handler() {
        this.setCount = null;
      },
      deep: true
    }
  },

  data() {
    return {
      setCount: 0
    };
  },

  methods: {
    times
  },

  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs;
    },
    lots() {
      const count = this.count ? Array.from(new Array(this.count)).map((v, i) => i + 1) : times(this.harvest.min_count, this.harvest.available_count);
      if (!this.includesZero) return count;
      if (count[0] !== 0) count.unshift(0);
      return count;
    },
    upTo() {
      if (this.harvest.available_count < this.harvest.min_count) {
        return this.$t("up_to")(this.harvest.available_count, this.harvest.available_count);
      }

      return this.$t("up_to")(this.harvest.min_count, this.harvest.available_count);
    }
  }
};
</script>

<style lang="scss" scoped>
  .product-color-count {
  width: 90%;

  .unit {
    margin-left: 2px;
    font-size: 12px;
  }

  &-price {
    font-weight: bold;
    font-size: 20px;
    color: #212121;
    overflow-wrap: anywhere;
  }

  &-sum {
    font-weight: bold;
    font-size: 24px;
    color: #ff8c71;
  }
}

.product-color-total {

  .unit {
    margin-left: 2px;
    font-weight: 400;
    font-size: 14px;
    line-height: 12px;
    letter-spacing: 0.1em;
  }

  &-price {
    font-weight: bold;
    color: #212121;
    font-size: 16px;
    line-height: 17px;
    overflow-wrap: anywhere;
  }

  &-unit {
    font-size: 18px;
    line-height: 22px;
  }

  &-sum {
    font-weight: bold;
    color: #ff8c71;
    font-size: 20px;
    line-height: 24px;
    overflow-wrap: anywhere;
  }

  &-delivery-fee {
    font-size: 14px;
    line-height: 17px;
  }
}
</style>
